import React from "react";
import PropTypes from "prop-types";

const RlNavContent = ({ children }) => (
  <section id="content-column" className="sample-details__main-content">
    {children}
  </section>
);
RlNavContent.propTypes = {
  children: PropTypes.node.isRequired
};
export default RlNavContent;
